export default __webpack_public_path__ + "static/media/bg4.7cbb3fc0.jpg";